<template>

  <hit_login>

    <hit_dashboard >
  <div>

    <div class="hit-form-group" >

        <div class="hit-panel hit-panel-warning">
        <div class="hit-panel-heading" v-if="get_board()">

          <h4 class="hit-html-h4">{{ get_board().name }}</h4>

        </div>
        <div class="hit-panel-body" v-if="get_board()">

    <div class="hit-alert hit-alert-danger" v-if="deleted">
      {{ $tc("message.noEntry", 1) }}
    </div>

    <div class="hit-row" v-if="!deleted">
    <div class="hit-col-md-4 hit-text-center hit-text-warning">
      <div class="hit-form-group">
        <hit_icon :defaults="'board'" style="font-size: 5em;"/>
        <div style="font-size: 3em; line-height: 1em;">{{ get_board().ID }}</div>

      </div>
    </div>

    <div class="hit-col-md-8">
      <div class="hit-col-md-12">
        <div class="hit-form-group">
          <router-link class="hit-btn hit-btn-warning hit-btn-block" :to="{ name: 'embed', params: {lang: $store.getters.lang, boardID: get_board().ID} }">{{ $t("message.embed") }}</router-link>
        </div>
      </div>

      <div class="hit-col-md-12">
        <div class="hit-form-group">
          <router-link class="hit-btn hit-btn-warning hit-btn-block" :to="{ name: 'landingpage', params: {lang: $store.getters.lang, username: $store.getters.user.username, boardID: get_board().ID} }">{{  $t('message.website') }}</router-link>
        </div>
      </div>

      <div class="hit-col-md-12">
        <div class="hit-form-group">
          <router-link class="hit-btn hit-btn-warning hit-btn-block" :to="{ name: 'feedback_board', params: {board: get_board().ID, lang: $store.getters.lang} }">{{ $tc('message.feedback', 0) }}</router-link>
        </div>
      </div>

      <div class="hit-col-md-12">
        <div class="hit-form-group">
          <router-link class="hit-btn hit-btn-warning hit-btn-block" :to="{ name: 'board_targetpage', params: {board: get_board().ID, lang: $store.getters.lang} }">{{ $tc('message.targetPage', 2) }}</router-link>
        </div>
      </div>

      <div class="hit-col-md-12">
        <div class="hit-form-group">
          <a href="#" class="hit-btn hit-btn-warning hit-btn-block" v-on:click.prevent="get_subcomponent('invitation')">{{ $tc('message.invitation', 0) }}</a>
        </div>
      </div>

      <div class="hit-col-md-12">
        <div class="hit-form-group">
          <boardDelete class="hit-text-right" :edit="{row: get_row()}" :callback="function(){ set_delete(); }"/>
        </div>
      </div>

    </div>

    <transition name="fade">
      <div class="hit-col-md-12" v-if="sub_component">

        <div class="hit-col-md-12">
          <div class="hit-form-group">
            <component v-bind:is="sub_component" :edit="{row: get_row()}"/>
          </div>
        </div>

      </div>
    </transition>

    </div>

  </div>

  <div class="hit-panel-footer" v-if="$store.getters.lang" >
    <div class="hit-text-left">
      <router-link :to="{ name: 'boards', params: {lang: $store.getters.lang} }" class="hit-html-a">{{ $t("message.goTo", {name: $t("message.boardOverview")}) }}</router-link>
    </div>
  </div>

  </div>

  </div>
  </div>

</hit_dashboard>

</hit_login>
</template>

<script>

import boardDelete from '@core/components/content/app/board/board_delete'
import invitation from '@core/components/content/app/board/board_invitation'

export default{
  // props: { edit: Object},
  components: { boardDelete, invitation },

  data () {
    return {
      edit: {row: false},
      deleted: false,
      sub_component: false
    }
  },
  methods: {

    get_row () {
      var id = false

      for (var i = 0; i < this.$store.getters.boards.length; i++) {
        if (this.$store.getters.boards[i].ID == this.$route.params.id) {
          id = i
          return id
        }
      }

      return id
    },

    get_board () {
      if (typeof this.$store.getters.boards_by_id === 'undefined') { return false }

      return this.$store.getters.boards_by_id[this.$route.params.id]
    },

    get_subcomponent (id) {
      if (this.sub_component === id) {
        this.sub_component = false
        return false
      }

      this.sub_component = id
    },

    set_delete () {
      this.deleted = true
    }
  },
  mounted () {
    this.$store.dispatch('get_user_boards')
    this.$store.dispatch('get_all_votes')
  }
}
</script>
